import { Trans } from '@lingui/react/macro';

import { useChannelTrafficOverviewKPIs } from '@/api/channel';
import { KpiMetric, KpiMetricGroup } from '@/components/kpi';
import { usePageFilterContext } from '@/components/page';
import { numberFormat } from '@/helper/numberFormatter';

type Props = {
  channelId?: string;
};

const ChannelDetailKPIMetrics = ({ channelId }: Props) => {
  const { pageFilters } = usePageFilterContext();
  const { startDate, endDate, audience } = pageFilters;
  const {
    channelTrafficOverviewKPIs: data,
    isLoading,
    error,
  } = useChannelTrafficOverviewKPIs(channelId, startDate, endDate, audience?.id);

  return (
    <KpiMetricGroup>
      <KpiMetric
        label={<Trans>All Visits</Trans>}
        value={data && numberFormat(data.visits, { precision: 0 })}
        isLoading={isLoading}
        error={error}
      />
      <KpiMetric
        label={<Trans>Total Spend</Trans>}
        value={data && numberFormat(data.spend, { isCurrency: true, precision: 0 })}
        isLoading={isLoading}
        error={error}
      />
      <KpiMetric
        label={<Trans>All $/Visit</Trans>}
        value={data && numberFormat(data.spendPerVisit, { isCurrency: true })}
        isLoading={isLoading}
        error={error}
      />
      <KpiMetric
        label={audience?.isTAM ? <Trans>TAM Visits</Trans> : <Trans>{audience?.name} Visits</Trans>}
        value={data && numberFormat(audience?.isTAM ? data.tamVisits : data.audienceVisits)}
        isLoading={isLoading}
        error={error}
      />
      <KpiMetric
        label={
          audience?.isTAM ? <Trans>TAM $/Visit</Trans> : <Trans>{audience?.name} $/Visit</Trans>
        }
        value={
          data &&
          numberFormat(audience?.isTAM ? data.spendPerTamVisit : data.spendPerAudienceVisit, {
            isCurrency: true,
          })
        }
        isLoading={isLoading}
        error={error}
      />
    </KpiMetricGroup>
  );
};

export default ChannelDetailKPIMetrics;
